export type JsonRecord = Record<string, unknown>;

export function stringifyValue(value: unknown): string {
  if (value === null || value === undefined) return "-";
  return typeof value === "object" ? JSON.stringify(value) : String(value);
}

export function JsonKeyValues({ value }: { value: JsonRecord }) {
  const entries = Object.entries(value ?? {});
  if (entries.length === 0) {
    return <span className="text-fg-3">-</span>;
  }
  return (
    <dl className="grid gap-1">
      {entries.map(([key, val]) => (
        <div key={key} className="grid grid-cols-[110px_minmax(0,1fr)] gap-2 text-12-regular">
          <dt className="font-semibold text-fg-2">{key}</dt>
          <dd className="min-w-0 break-words text-fg-1">{stringifyValue(val)}</dd>
        </div>
      ))}
    </dl>
  );
}

export function JsonDiff({ before, after }: { before: JsonRecord; after: JsonRecord }) {
  const keys = Array.from(new Set([...Object.keys(before), ...Object.keys(after)])).sort();
  if (keys.length === 0) {
    return <span className="text-fg-3">-</span>;
  }

  return (
    <div className="grid gap-1">
      {keys.map((key) => {
        const inBefore = key in before;
        const inAfter = key in after;
        const beforeStr = stringifyValue(before[key]);
        const afterStr = stringifyValue(after[key]);
        if (!inBefore) {
          return (
            <p key={key} className="break-words text-12-regular text-score-a">
              <strong>+ {key}:</strong> {afterStr}
            </p>
          );
        }
        if (!inAfter) {
          return (
            <p key={key} className="break-words text-12-regular text-score-c line-through">
              <strong>- {key}:</strong> {beforeStr}
            </p>
          );
        }
        if (beforeStr !== afterStr) {
          return (
            <p key={key} className="break-words text-12-regular text-[#B25612]">
              <strong>{key}:</strong> {beforeStr} -&gt; {afterStr}
            </p>
          );
        }
        return (
          <p key={key} className="break-words text-12-regular text-fg-3">
            <strong>{key}:</strong> {afterStr}
          </p>
        );
      })}
    </div>
  );
}
